import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const AssetListView = ({ assets, selectedAssets, onSelect, onPreview, onAction }) => {
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes?.[i];
  };

  const getFileIcon = (type) => {
    const iconMap = {
      image: 'Image',
      video: 'Video',
      document: 'FileText',
      icon: 'Sparkles'
    };
    return iconMap?.[type] || 'File';
  };

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted border-b border-border">
            <tr>
              <th className="w-12 px-4 py-3">
                <input
                  type="checkbox"
                  className="w-4 h-4 rounded border-border"
                  aria-label="Select all assets"
                />
              </th>
              <th className="text-left px-4 py-3 caption font-semibold text-foreground">
                Name
              </th>
              <th className="text-left px-4 py-3 caption font-semibold text-foreground hidden md:table-cell">
                Type
              </th>
              <th className="text-left px-4 py-3 caption font-semibold text-foreground hidden lg:table-cell">
                Size
              </th>
              <th className="text-left px-4 py-3 caption font-semibold text-foreground hidden lg:table-cell">
                Uploaded
              </th>
              <th className="w-12 px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {assets?.map((asset) => {
              const isSelected = selectedAssets?.includes(asset?.id);
              return (
                <tr
                  key={asset?.id}
                  className={`border-b border-border hover:bg-muted/50 transition-all duration-250 ${
                    isSelected ? 'bg-primary/5' : ''
                  }`}
                >
                  <td className="px-4 py-3">
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => onSelect(asset?.id)}
                      className="w-4 h-4 rounded border-border"
                      aria-label={`Select ${asset?.name}`}
                    />
                  </td>
                  <td className="px-4 py-3">
                    <button
                      onClick={() => onPreview(asset)}
                      className="flex items-center gap-3 hover:opacity-80 transition-opacity"
                    >
                      <div className="w-10 h-10 bg-muted rounded flex items-center justify-center flex-shrink-0 overflow-hidden">
                        {asset?.type === 'image' ? (
                          <Image
                            src={asset?.thumbnail}
                            alt={asset?.thumbnailAlt}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <Icon name={getFileIcon(asset?.type)} size={20} className="text-muted-foreground" />
                        )}
                      </div>
                      <span className="caption font-medium text-foreground text-left">
                        {asset?.name}
                      </span>
                    </button>
                  </td>
                  <td className="px-4 py-3 hidden md:table-cell">
                    <span className="text-sm text-muted-foreground uppercase">
                      {asset?.format}
                    </span>
                  </td>
                  <td className="px-4 py-3 hidden lg:table-cell">
                    <span className="text-sm text-muted-foreground">
                      {formatFileSize(asset?.size)}
                    </span>
                  </td>
                  <td className="px-4 py-3 hidden lg:table-cell">
                    <span className="text-sm text-muted-foreground">
                      {asset?.uploadDate}
                    </span>
                  </td>
                  <td className="px-4 py-3">
                    <button
                      onClick={() => onAction(asset?.id)}
                      className="p-2 rounded-lg hover:bg-muted transition-all duration-250"
                      aria-label="Asset actions"
                    >
                      <Icon name="MoreVertical" size={16} className="text-muted-foreground" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AssetListView;